import axios from 'axios';
import { STORAGE_KEY } from '../utils/constants';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'x-client-id': process.env.REACT_APP_API_CLIENT_ID,
        'x-client-secret': process.env.REACT_APP_API_CLIENT_SECRET,
    },
});

api.interceptors.request.use(
    (config) => {
        const token =
            localStorage.getItem(STORAGE_KEY) ||
            sessionStorage.getItem(STORAGE_KEY);

        if (token && !config?.headers?.skipAuth) {
            config.headers['token'] = `${token}`;
        } else if (config?.headers?.skipAuth) {
            delete config.headers.skipAuth;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

let alreadyHandlingTokenExpired = false;

export function resetTokenExpiredHandling() {
    alreadyHandlingTokenExpired = false;
}

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const data = error?.response?.data;
        const status = error?.response?.status;
        const errorCode = data?.error;

        const skipGlobalAuthError = error?.config?.headers?.skipGlobalAuthError;

        if (!skipGlobalAuthError) {
            if ((status === 401 || status === 403) && !alreadyHandlingTokenExpired) {
                if (errorCode === 'Token Expired') {
                    window.dispatchEvent(new CustomEvent('api:tokenExpired'));
                    alreadyHandlingTokenExpired = true;
                } else if (errorCode === 'Deactivated Account') {
                    window.dispatchEvent(new CustomEvent('api:deactivatedAccount'));
                } else {
                    window.dispatchEvent(new CustomEvent('api:unauthorized'));
                }
            } else if (status === 500) {
                if (errorCode === 'Deactivated Account') {
                    window.dispatchEvent(new CustomEvent('api:deactivatedAccount'));
                }
            }
        }

        return Promise.reject(error);
    }
);

export { api };
